import React, { Component } from "react";

import ServiceButton from "../button/category-button";

class CategoryNavigation extends Component
{
    getButton = (id, type, slug, name, isActive) => {

        let url = slug === "all" ? `/${ type }${ type === "blog" ? "#our-blog" : "" }` : `/${ type }/${ slug }${ type === "blog" ? "#our-blog" : "" }`;

        return (
            <ServiceButton
                key = { `service-button-${url}` }
                to = { url }
                title = { name }
                target = ''
                serviceSlug = { slug }
                isActive = { isActive }
            >
                <span dangerouslySetInnerHTML={{ __html: name }}></span>
            </ServiceButton>
        );
    }

    getServices = (type, activeSlug) => {
        let services = this.props.contentButtonData;

        let buttons = [];
        let categoryIds = [];
        let categorySlugs = [];
        let categoryNames = [];

        // add categories into arrays (slug and name)
        for (let i = 0; i < services.length; i++) {
            categoryIds.push( services[i].databaseId );
            categorySlugs.push( services[i].slug );
            categoryNames.push( services[i].name?.length > 0 ? services[i].name : services[i].title );
        }

        // add nav buttons into arrays
        for (let i = 0; i < categoryNames.length; i++) {
            let id = categoryIds[i];
            let slug = categorySlugs[i];
            let name = categoryNames[i];

            switch (type) {
                case "blog":
                    buttons.push( this.getButton( id, "blog", slug, name, slug === activeSlug ) );
                    break;
                case "case-study":
                    buttons.push( this.getButton( id, "stories", slug, name, slug === activeSlug ) );
                    break;
                case "report":
                    buttons.push( this.getButton( id, "reports", slug, name ) );
                    break;
                default :
                    break;
            }
        }

        return buttons;
    }

    render () {
        let buttons = this.getServices(this.props.type, this.props.active);

        return (
            <header className={this.props.type === "blog" ? "blog-category-nav-header" : ""}>
                <div className="blog-category-nav">
                    <div className='filter-buttons' id='category_nav_bar'>
                        { buttons }
                    </div>
                </div>
            </header>
        )
    }
}

export default CategoryNavigation;